export default {
  name: `rotate_screen`,
  cta: `пожалуйста, поверните экран`,
};
